import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterASquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLetterASquare"><Path d="M12.0527 9.3125L13.1895 12.8457H10.8164L11.9531 9.3125H12.0527Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.1504 7.74219L8.15039 16.1973H9.73242L10.4355 14.0117H13.5645L14.2734 16.1973H15.8555L12.8555 7.74219H11.1504Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterASquare;
